const TitleH1 = ({
  className,
  title,
}: {
  className?: string;
  title: React.ReactNode;
}) => {
  return (
    <h1
      className={`text-primary text-3xl font-normal tracking-wider md:text-4xl lg:text-5xl ${className}`}
    >
      {title}
    </h1>
  );
};

export default TitleH1;
